import { ReactComponent as YuJaLogo } from "../../images/yujalogo.svg";
import { ReactComponent as NavbarArrow } from "../../images/navbar_arrow_purple.svg";
import { ReactComponent as LogOut } from "../../images/LogoutIcon.svg";
import { ReactComponent as Support } from "../../images/SupportIcon.svg";
import {ReactComponent as INSTITUTIONS} from "../../images/bank_gray_icon.svg";
import {ReactComponent as INSTITUTION_ADD} from "../../images/bank_plus_gray_icon.svg";
import {ReactComponent as MANAGE_CSM_USERS} from "../../images/manage_users.svg";
import {ReactComponent as ADMIN_PATTERN} from "../../images/user_settings_icon.svg";
import {ReactComponent as EVENTS} from "../../images/event_banner_icon.svg";
import {useHistory} from "react-router-dom";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {useCookie} from "../../hooks/useCookie";
import {useSession} from "../../hooks/useSession";
import {AuthenticationApiCalls} from "../../apis/AuthenticationApiCalls";
import {
    CREATE_POLL_PATH,
    CSM_ADD_INSTITUTION_PATH,
    CSM_ADMIN_PATTERNS_PATH,
    CSM_CSM_MANAGEMENT_PATH,
    CSM_EVENTS_PATH,
    CSM_HOME_PATH,
    MENU_LIST,
    YUJA_SUPPORT_LINK
} from "../../utils/constants";
import {useTranslation} from "react-i18next";
import { translatePageIdentifier } from "../../utils/menuLabel";
import React, {useEffect, useRef, useState} from "react";
import styles from "../../components/YuJaNavbar.module.css";
import ProfileIcon from "../../components/ProfileIcon";
import {useCSMAccessCheck} from "../../hooks/useCSMAccessCheck";
import { Popover } from '@base-ui/react/popover';
import { Separator } from '@base-ui/react/separator';
import {Button} from "@base-ui/react/button";
import OverflowText from "../../components/OverflowText";


export default function CSMNavBar({ pageIdentifier }) {
    const {t} = useTranslation();
    const history = useHistory();
    const [, getSession] = useLocalStorageNew("session", {});
    const [, getCookie] = useCookie("name", "Guest");
    const {parseSessionToken} = useSession();
    const { logout } = AuthenticationApiCalls();
    const {isCSMAdmin} = useCSMAccessCheck();


    const session = getSession();
    const [pinCode, setPinCode] = useState("");
    const popoverRef = useRef(null);
    const [menuItemList, setMenuItemList] = useState([]);

    const anonymous = !session.userName;
    let userName;
    if (anonymous) {
        userName = getCookie();
    } else {
        if (session.firstName && session.lastName) {
            userName = session.firstName + " " + session.lastName;
        } else if (session.firstName) {
            userName = session.firstName;
        } else {
            userName = session.userName;
        }
    }
    let email = session.email;
    let names = userName.split(" ");

    let initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }


    const logoutFunction = () => {
        closeProfileMenu();
        if (window.location.pathname.startsWith(MENU_LIST.CREATE.path) || window.location.pathname.startsWith(MENU_LIST.CREATE.altPath)) {
            history.push({
                pathname: CREATE_POLL_PATH,
                state: {pollType: t("poll.gradedPollLabel"), fromNavbar: true, previous: CREATE_POLL_PATH, logout: true}
            })
        }
        else {
            logout();
        }
    };

    const closeProfileMenu = () => {
        if (popoverRef.current) {
            popoverRef.current.close();
        }
    }

    useEffect(() => {
        let payLoad = parseSessionToken();
        if (!!payLoad) {
            const {pinCode=""} = payLoad;
            setPinCode(!!pinCode ? pinCode : "");
        }

        const copy = [];
        copy.push({
            icon: INSTITUTIONS,
            label: t("institution.institutionsTitle"),
            onClick: () => {
                history.push(CSM_HOME_PATH);
                closeProfileMenu();
            }
        });
        copy.push({
            icon: INSTITUTION_ADD,
            label: t("institution.installLabel"),
            onClick: () => {
                history.push(CSM_ADD_INSTITUTION_PATH);
                closeProfileMenu();
            }
        });

        if (isCSMAdmin()) {
            copy.push({
                icon: MANAGE_CSM_USERS,
                label: t("institution.manageCsm"),
                onClick: () => {
                    history.push(CSM_CSM_MANAGEMENT_PATH);
                    closeProfileMenu();
                }
            });
            copy.push({
                icon: ADMIN_PATTERN,
                label: t("institution.adminPatterns"),
                onClick: () => {
                    history.push(CSM_ADMIN_PATTERNS_PATH);
                    closeProfileMenu();
                }
            });
        }

        copy.push({
            icon: EVENTS,
            label: t("institution.events"),
            onClick: () => {
                history.push(CSM_EVENTS_PATH);
                closeProfileMenu();
            }
        });


        copy.push({
            icon: Support,
            label: t("poll.accountCardSupportText"),
            onClick: () => {
                window.open(YUJA_SUPPORT_LINK);
                closeProfileMenu();
            }
        });

        copy.push({
            icon: LogOut,
            label: t("poll.accountCardLogoutText"),
            onClick: () => logoutFunction()
        });

        setMenuItemList(copy);
    }, []);



    return (
        <div id="viewer-navbar-container" className={styles.navBarContainer}>
            <div className={styles.logoContainer}>
                <YuJaLogo width={24} height={24}/>
            </div>
            <span className={styles.pathContainer}>
                {t("navigation.engageCsm")}
                <NavbarArrow style={{margin: "0 5px", width: 8}}/>
                {translatePageIdentifier(pageIdentifier)}
            </span>

            <div style={{flex: 1, minWidth: 0, height: "100%"}}></div>

            <Popover.Root modal={"trap-focus"} actionsRef={popoverRef}>
                <Popover.Trigger id={"profile-btn"} className={styles.profileBtn} aria-label={t("accessibility.myProfile")}>
                    <ProfileIcon
                        size={33}
                        initialLetter={initials[0] ? initials[0] : "G"}
                    />
                </Popover.Trigger>
                <Popover.Portal >
                    <Popover.Positioner sideOffset={5} style={{zIndex: 1000}} align={"end"}>
                        <Popover.Popup >
                            <div className={styles.profileMenuContainer}>
                                <div style={{width: 180, display: "flex", flexDirection: "column", alignItems: "center"}}>
                                    <ProfileIcon
                                        size={45}
                                        initialLetter={initials[0] ? initials[0] : "G"}
                                        style={{margin: 10}}
                                    />
                                    <div
                                        title={userName}
                                        style={{
                                            textAlign: "center", fontWeight: 700, maxWidth: "175px",
                                            fontSize: 20, lineHeight: 1.4, overflow: "hidden", whiteSpace: "nowrap",
                                            textOverflow: "ellipsis", paddingLeft: "10px", paddingRight: "10px"
                                        }}
                                    >{userName} </div>
                                    <div style={{color: "#6F6F6F", fontSize: 14, lineHeight: 1.6,}}>
                                        {isCSMAdmin() ? t("institution.csmAdmin") : "CSM"}
                                    </div>
                                    <div
                                        title={email}
                                        style={{
                                            overflow: "hidden", maxWidth: "175px",
                                            textOverflow: "ellipsis", whiteSpace: "nowrap",
                                            fontSize: "14px", lineHeight: 1.6, paddingLeft: "10px", paddingRight: "10px"
                                        }}
                                    > {email} </div>
                                    {!!pinCode &&
                                        <div style={{color: "#6F6F6F", fontSize: "14px", lineHeight: 1.6,}}>
                                            {`PIN: ${pinCode}`}
                                        </div>
                                    }
                                </div>
                                <Separator orientation="horizontal" className={styles.separator}/>
                                <ul
                                    id={"profile-menu"}
                                    aria-label={"user-profile"}
                                    role={"menu"}
                                    className={styles.profileMenu}
                                >
                                    {menuItemList.map((item, index) => {
                                        const {icon, label, onClick} = item;
                                        const Icon = icon;
                                        return (
                                            <li key={index}>
                                                <Button
                                                    className={styles.profileMenuItem}
                                                    autoFocus={index === 0}
                                                    aria-label={label}
                                                    onClick={() => onClick()}
                                                >
                                                    <Icon style={{width: 24, height: 24}} focusable={false}
                                                          role={"presentation"}/>
                                                    <OverflowText>{label}</OverflowText>
                                                </Button>

                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>

                        </Popover.Popup>
                    </Popover.Positioner>
                </Popover.Portal>
            </Popover.Root>
        </div>
    );
}